import React, { useEffect, useState } from 'react'
import hmCoin from '../Images/hamster-coin.webp'
import { FaXTwitter } from 'react-icons/fa6'
import { BiLogoTelegram } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { MdOutlineArrowOutward } from 'react-icons/md'
import image from '../Images/5.png'
import firebaseApp from '../Firebase/firebase'
import Loader from './Loader'
import moment from 'moment/moment'
import Countdown from 'react-countdown'
import axios from 'axios'

export default function Task() {

    const [combo, setCombo] = useState([])
    const [cipher, setCipher] = useState([])
    const [showLoader, setShowLoader] = useState(true)
    let today = new Date()
    today.setHours(29, 30, 0, 0)
    const [date, setDate] = useState(today.getTime())
    useEffect(() => {
        getDailyCombo()
        getDailyCipher()
        setDate(today.getTime())
    }, [])


    const navigate = useNavigate()
    const openPDF = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/hamster-kombat-clone-dab00.appspot.com/o/PDF%2Fhamster_kombat_me_whitepaper.pdf?alt=media&token=0992b03c-c980-44fc-b3dc-b228d03e85de'
    }
    const goToTwitter = () => {
        window.location.href = "https://x.com/HKombat_coin?t=PM4qOLqo8Rd1kbENmXYMNg&s=09"
    }
    const goToTg = () => {
        window.location.href = "https://t.me/hamster_kombat_game_coin"
    }

    const getDailyCipher = () => {
        axios.get(process.env.REACT_APP_API_URL + '/task/get-today-cipher')
            .then((res) => {
                if (res.status == 200) {
                    let word = res.data.word
                    setCipher(word.split(''))
                    setShowLoader(false)
                }
            })
    }

    const getDailyCombo = () => {

        axios.get(`${process.env.REACT_APP_API_URL}` + '/task/get-today-combo')
            .then((res) => {
                if (res.status == 200) {
                    setCombo(res.data.task)
                    setShowLoader(false)
                }
            })
    }


    const returnCategory = (num) => {
        if (Number(num) == 0) {
            return "PR & Team"
        }
        if (Number(num) == 1) {
            return "Markets"
        }
        if (Number(num) == 2) {
            return "Legal"
        }
        if (Number(num) == 3) {
            return "Web3"
        }
        if (Number(num) == 4) {
            return "Specials"
        }
    }

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
        } else {
            // Render a countdown
            return <span>{hours}:{minutes}:{seconds}</span>;
        }
    };
    const morse = {
        "A": "• —",
        "B": "— • • •",
        "C": "— • — •",
        "D": "— • •",
        "E": "•",
        "F": "• • — •",
        "G": "— — •",
        "H": "• • • •",
        "I": "• •",
        "J": "• — — —",
        "K": "— • —",
        "L": "• — • •",
        "M": "— —",
        "N": "— •",
        "O": "— — —",
        "P": "• — — •",
        "Q": "— — • —",
        "R": "• — •",
        "S": "• • •",
        "T": "—",
        "U": "• • —",
        "V": "• • • —",
        "W": "• — —",
        "X": "— • • —",
        "Y": "— • — —",
        "Z": "— — • •"
    };



    return (
        <>
            {showLoader ? <Loader /> : ""}
            <div className='container-fluid text-white'>
                <div className="upper-nav d-flex justify-content-between flex-wrap">
                    <div className="join-us-icon">
                        <div className="join-us-btn d-flex align-items-center w-100 justify-content-between ">
                            <div className="join-btn" onClick={goToTwitter}>
                                <FaXTwitter className='btn-icon' />
                            </div>
                            <div className="join-btn" onClick={goToTg}>
                                <BiLogoTelegram className='btn-icon' />
                            </div>
                            <h6 className='dull-text m-0'>Join us!</h6>
                        </div>
                    </div>
                    <div className="center-heading">
                        <div className="heading-img-div">
                            <img src={hmCoin} width={100} alt="" />
                        </div>
                        <div>
                            <h3 className='text-center m-0'>Hmaster Kombat</h3>
                            <h3 className='text-center m-0'>Coin Daily Task</h3>
                        </div>
                    </div>
                    <div className="whitepaper">
                        <div className="whitepaper-btn mt-4" onClick={openPDF}>
                            <h6 className='m-0'>Whitepaper</h6>
                            <MdOutlineArrowOutward />
                        </div>
                        <span className='whitepaper-comming-soon cursor-pointer' onClick={() => navigate('/tasks')}>Daily Tasks</span>
                    </div>
                </div>
                <div className="combo-section mt-5 container">
                    <h3 className="text-center">
                        Today's Daily Combo in Hamster Kombat Game
                    </h3>
                    <p className='text-center'>{moment(Date.now()).format('DD-MM-YYYY')} – Next update:  <Countdown
                        date={date}
                        renderer={renderer}
                    /></p>
                    <div className="row mt-5">
                        {combo && combo.map((item) => (
                            <div className="col-md-4 mt-3">
                                <div className="combo-card border shadow rounded">
                                    <div className="image-part">
                                        <img src={item.img} alt="" />
                                        <h5>{item.label}</h5>
                                        <h6>{returnCategory(item.category)}</h6>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="cipher-section container mt-5 mb-5">
                    <div className="cipher-parent rounded text-center">
                        <h3>Daily Morse Code Solution for Hamster Kombat</h3>
                        <p className='mt-3'>This is a Morse code cipher. A dot (•) means a short tap, and a dash (—) means a long tap on the hamster.</p>
                        <div className="cipher-box rounded">
                            {cipher && cipher.map((item) => (
                                <div className="cipher-item rounded">
                                    <h3 className='m-0'>{item}</h3>
                                    <h6 className='m-0'>{morse[item]}</h6>
                                </div>
                            ))}
                        </div>
                        <p className='mt-5'>Date : {moment().format('DD-MM-YYYY')}</p>
                        <p>Next update in:  <Countdown
                            date={date}
                            renderer={renderer}
                        /></p>
                    </div>
                </div>
            </div>
        </>
    )
}
